const STYLES = {
  BAIK: "bg-emerald-600 text-white",
  "RUSAK RINGAN": "bg-amber-500 text-white",
  "RUSAK BERAT": "bg-rose-600 text-white",
  LAINNYA: "bg-slate-200 text-slate-700",
};

export const KAT_DOT = {
  BAIK: "bg-emerald-600",
  "RUSAK RINGAN": "bg-amber-500",
  "RUSAK BERAT": "bg-rose-600",
  LAINNYA: "bg-slate-400",
};

export const KondisiBadge = ({ kat, raw, testId }) => {
  const label = (raw || "").split("\n")[0].trim() || "-";
  return (
    <span
      data-testid={testId}
      title={raw}
      className={`inline-flex items-center px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide rounded-sm whitespace-nowrap ${STYLES[kat] || STYLES.LAINNYA}`}
    >
      {label.length > 22 ? `${label.slice(0, 22)}…` : label}
    </span>
  );
};
